import React, { useEffect, useState } from "react";
import { Flex, Modal, Spin } from "antd";
import { CiCirclePlus } from "react-icons/ci";
import FilterIcon from "../../../../Assets/Images/Svg/FilterIcon.svg";
import DeviceSetUpTable from "./deviceSetupTable";
import { useDispatch, useSelector } from "react-redux";
import nodatafound from "../../../../Assets/Icons/NoDataCard2.svg";
import { fetchRpmDevicesList } from "../../../../Redux/actions/rpmActions";
import NewDeviceSetUp from "./newDeviceSetUp";
import Layout from "../../../Layouts";
import DeviceFilter from "./deviceFilter";

function Index() {
  const [currentPage, setCurrentPage] = useState(1);
  const [newDeviceMod, setNewDeviceMod] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [deviceFiltered, setDeviceFiltered] = useState(false);
  const { isLoading, devicesList } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  useEffect(() => {
    const payload = {
      status: 1,
      devicesCreatedBy: loginResultObject?.user?.userId,
    };
    dispatch(fetchRpmDevicesList(payload));
  }, [dispatch, loginResultObject?.user?.userId]);

  const handleNewDevCreateMod = () => {
    setNewDeviceMod(!newDeviceMod);
  };

  const handleFilterModal = () => {
    setFilterModal(!filterModal);
  };

  const handleClearFilter = () => {
    setCurrentPage(1);
    setDeviceFiltered(false);
    dispatch(fetchRpmDevicesList({ status: 1 }));
  };

  return (
    <Layout>
      <div className="p-3">
        <div className="flex justify-between items-center py-3 px-6 sticky top-3">
          <div className="">
            <h1 className="font-bold text-xl">Device Setup</h1>
          </div>
          <div className="flex gap-4">
            <div>
              <button
                onClick={handleNewDevCreateMod}
                className="w-20 h-9 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md"
              >
                <span className="w-5 h-5">
                  <CiCirclePlus className="w-full text-[#189FAA] h-full" />
                </span>
                <span className="">New</span>
              </button>
            </div>
            <div>
              <button
                onClick={handleFilterModal}
                className="w-20 h-9 px-2 flex items-center rounded-md gap-2 bg-brand-primaryColor"
              >
                <span>
                  <img src={FilterIcon} alt="Icon" />
                </span>
                <span className="text-white"> Filter</span>
              </button>
            </div>
            {deviceFiltered && (
              <button
                onClick={handleClearFilter}
                className="h-9 px-3 flex items-center rounded-md gap-2 border border-brand-primaryColor text-brand-primaryColor bg-white"
              >
                Clear Filter
              </button>
            )}
          </div>
        </div>

        <div
          className={`${
            isLoading === false && devicesList?.length === 0
              ? "w-full flex justify-center items-center"
              : ""
          }`}
        >
          {isLoading && devicesList?.length === 0 ? (
            <div className="flex items-center justify-center mt-[10%]">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          ) : devicesList?.length === 0 ? (
            <div className="flex flex-col items-center justify-center">
              <img
                src={nodatafound}
                alt="nodatafound"
                className="h-min w-min"
              />
              <p className="font-medium text-xl">No data found!!</p>
            </div>
          ) : (
            <div>
              <DeviceSetUpTable
                data={devicesList}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalCount={devicesList?.length}
              />
            </div>
          )}
        </div>

        <Modal
          title="Add new device"
          open={newDeviceMod}
          onCancel={handleNewDevCreateMod}
          footer={[]}
          destroyOnClose
        >
          <NewDeviceSetUp handleCloseModal={handleNewDevCreateMod} />
        </Modal>

        <Modal
          title="Filter"
          open={filterModal}
          onCancel={handleFilterModal}
          footer={[]}
          destroyOnClose
        >
          <DeviceFilter
            handleClose={handleFilterModal}
            setDeviceFiltered={setDeviceFiltered}
            setCurrentPage={setCurrentPage}
          />
        </Modal>
      </div>
    </Layout>
  );
}

export default Index;
